import { render, staticRenderFns } from "./OverwatchMap.vue?vue&type=template&id=0fac2346&"
import script from "./OverwatchMap.vue?vue&type=script&lang=js&"
export * from "./OverwatchMap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports